export const PRESCRIPTION_STORAGE_KEY_PREFIX = 'svm_prescription_';
